import { render, staticRenderFns } from "./ProfileHero.vue?vue&type=template&id=db7e91f6&scoped=true"
var script = {}
import style0 from "./ProfileHero.vue?vue&type=style&index=0&id=db7e91f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7e91f6",
  null
  
)

export default component.exports